"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoboxPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const analytics_1 = require("@completeanatomy/analytics");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const selectors_1 = require("../../selectors");
const getTabeNameForAnalytics_1 = require("../../utils/getTabeNameForAnalytics");
const lodash_1 = require("lodash");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("../../utils");
const PartsOverlay_1 = require("../PartsOverlay");
const desktop_1 = __importDefault(require("./desktop"));
const mobile_1 = __importDefault(require("./mobile"));
const deviceBreakpointSize = 899;
const selectSpecificDetails = (0, selectors_1.createPropertiesSelector)(selectors_1.selectDetails, 'names', 'audio');
function InfoboxPanel({ selectedOverlayItem, onOverlayClosed, isVisible, isOverlayOpened, isSearchPanel, setIsOverlayOpened, }) {
    const defaultTab = (0, hooks_1.useDefaultTab)();
    const selectedPart = (0, models_1.useSelectedPart)();
    const infoBoxDetails = (0, hooks_1.useSelector)(selectSpecificDetails);
    const [currentTab, setCurrentTab] = (0, react_1.useState)(bridge_schema_1.InfoBoxTabType.None);
    const [isSidePanelOpen, setIsSidePanelOpen] = (0, react_1.useState)(false);
    const [isOpenInfoboxMenu, setIsOpenInfoboxMenu] = (0, react_1.useState)(true);
    const [isInfoboxActive, setIsInfoboxActive] = (0, react_1.useState)(false);
    const { isActive: isMultiSelectActive } = (0, hooks_1.useMultiSelectState)();
    const buttonOverlayRef = (0, react_1.useRef)(null);
    const analytics = (0, analytics_1.useAnalytics)();
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const sendAnalytics = (0, react_1.useCallback)((type) => {
        analytics.log('infobox_item_selected', {
            tool_type: (0, getTabeNameForAnalytics_1.getTabeNameForAnalytics)(type),
        });
    }, [analytics]);
    const { names, audio } = infoBoxDetails || {};
    const isLower = (0, ui_1.useScreenBreakpoint)(deviceBreakpointSize);
    const getTitleText = (type) => {
        const infoboxTabName = (0, utils_1.getInfoboxTabName)(type);
        if (!infoboxTabName)
            return '';
        const tabName = i18n_1.Strings.infoBox.tabs[infoboxTabName];
        return t(tabName);
    };
    const isSpotPanelOpen = currentTab !== bridge_schema_1.InfoBoxTabType.Description &&
        currentTab !== bridge_schema_1.InfoBoxTabType.None;
    const isDescriptionPanelOpen = currentTab === bridge_schema_1.InfoBoxTabType.Description;
    const { items = [] } = (0, hooks_1.useTabContent)(currentTab) || {};
    const onItemClick = (0, react_1.useCallback)((type) => {
        sendAnalytics(type);
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(type);
        if (type === currentTab) {
            setIsSidePanelOpen(false);
            setTimeout(() => {
                setCurrentTab(bridge_schema_1.InfoBoxTabType.None);
            }, 700);
            return;
        }
        if (type === bridge_schema_1.InfoBoxTabType.Isolate) {
            bridge === null || bridge === void 0 ? void 0 : bridge.isolateAction({
                animated: true,
                activateExplodeIsolate: false,
            });
            setIsOverlayOpened(true);
            bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
                type: bridge_schema_1.InfoBoxTabType.Isolate,
                index: 0,
            });
            setIsSidePanelOpen(false);
        }
        else {
            setIsSidePanelOpen(true);
        }
        setCurrentTab(type);
    }, [currentTab, sendAnalytics, bridge, setIsOverlayOpened]);
    (0, react_1.useEffect)(() => {
        if (!selectedOverlayItem) {
            return;
        }
        setIsOverlayOpened(true);
    }, [selectedOverlayItem, setIsOverlayOpened]);
    (0, react_1.useEffect)(() => {
        setIsSidePanelOpen(false);
        if (!(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.identifier)) {
            setIsInfoboxActive(false);
            setCurrentTab(bridge_schema_1.InfoBoxTabType.None);
            bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(bridge_schema_1.InfoBoxTabType.None);
            return;
        }
        setIsInfoboxActive(true);
        if (!defaultTab || defaultTab === bridge_schema_1.InfoBoxTabType.None) {
            setCurrentTab(bridge_schema_1.InfoBoxTabType.None);
            bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(bridge_schema_1.InfoBoxTabType.None);
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(defaultTab);
        setCurrentTab(defaultTab);
        setIsSidePanelOpen(true);
    }, [selectedPart, defaultTab, bridge]);
    const onCloseOverlay = () => {
        if (currentTab === bridge_schema_1.InfoBoxTabType.Isolate) {
            setCurrentTab(bridge_schema_1.InfoBoxTabType.None);
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.exitIsolateMode();
        setIsOverlayOpened(false);
        onOverlayClosed === null || onOverlayClosed === void 0 ? void 0 : onOverlayClosed();
    };
    const panelProps = {
        audio,
        buttonOverlayRef,
        currentTab,
        information: selectedPart.information,
        isDescriptionPanelOpen,
        isOpenInfoboxMenu,
        isSidePanelOpen,
        isSpotPanelOpen,
        items,
        names,
        setIsSidePanelOpen,
        onItemClick,
        setCurrentTab,
        setIsOpenInfoboxMenu,
        setIsOverlayOpened,
    };
    return ((isInfoboxActive || isMultiSelectActive) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isSearchPanel && ((0, jsx_runtime_1.jsx)(Component, { "$isVisible": isVisible, "data-e2e": 'InfoboxPanel_Component', children: isLower ? ((0, jsx_runtime_1.jsx)(mobile_1.default, Object.assign({}, panelProps, { "data-e2e": 'InfoboxPanel_MobileInfoboxPanel' }))) : ((0, jsx_runtime_1.jsx)(desktop_1.default, Object.assign({}, panelProps, { "data-e2e": 'InfoboxPanel_DesktopInfoboxPanel' }))) })), (0, jsx_runtime_1.jsx)("div", { ref: buttonOverlayRef, "data-e2e": 'InfoboxPanel_div', children: isOverlayOpened && ((0, jsx_runtime_1.jsx)(ui_1.ModalProvider, { "data-e2e": 'InfoboxPanel_ModalProvider', children: (0, jsx_runtime_1.jsx)(PartsOverlay_1.PartsOverlay, { onCloseFullScreen: lodash_1.noop, onToggleFullScreen: lodash_1.noop, isOpen: isOverlayOpened, onClose: onCloseOverlay, name: getTitleText(currentTab), parts: items, currentTab: currentTab, "data-e2e": 'InfoboxPanel_PartsOverlay' }) })) })] })));
}
exports.InfoboxPanel = InfoboxPanel;
const Component = styled_components_1.default.div `
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`;
